// export const SERVER_URL = 'http://localhost:5000/';
// export const SERVER_URL = 'http://localhost:8080/';
// export const SERVER_URL = 'http://colesan-online-api.us-east-2.elasticbeanstalk.com/';
// export const SERVER_URL = 'https://api.colesanonline.com.br/';
// export const SERVER_URL = 'https://book.colesanonline.com.br/';
// export const SERVER_URL = 'http://ColesanOnlineApi-env.6kuypnqcm4.us-east-1.elasticbeanstalk.com/';

import env from "./env.json";
export const SERVER_URL = env.SERVER_URL_ENV;